import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useChatSettings } from '@guuru/chat-web';
import { Col, Typography } from 'antd';
import { CloseButton } from '@guuru/react-chatwidget';
import Header from './Header';
import GoBackLink from './GoBackLink';

const { Title } = Typography;

const CommunityHeader = function () {
  const {
    data: {
      chatSettings: {
        id: partnerId,
        name,
      },
    },
  } = useChatSettings();

  const { search } = useLocation();

  return (
    <Header>
      <Col span={1}>
        <GoBackLink />
      </Col>
      <Col style={{ textAlign: 'center' }}>
        <Title level={5}>
          <Link to={`/${partnerId}/home${search}`} replace>{name}</Link>
        </Title>
      </Col>
      <Col span={1}>
        <CloseButton />
      </Col>
    </Header>
  );
};

export default CommunityHeader;
